import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-08115ab9")

_pushScopeId("data-v-08115ab9")
const _hoisted_1 = { class: "preview" }
const _hoisted_2 = { class: "margin-left-10" }
const _hoisted_3 = /*#__PURE__*/_createVNode("strong", null, "标签: ", -1)
const _hoisted_4 = { class: "flex flex-wrap padding-10" }
const _hoisted_5 = { class: "image" }
const _hoisted_6 = {
  key: 0,
  class: "card-text"
}
const _hoisted_7 = { class: "tags" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_card = _resolveComponent("el-card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cardSetAssemblyParts, (cardSetAssemblyPart) => {
      return (_openBlock(), _createBlock("div", {
        class: "margin-top-10",
        key: cardSetAssemblyPart.id
      }, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(cardSetAssemblyPart.tagIds, (tagId) => {
            return (_openBlock(), _createBlock(_component_el_tag, { key: tagId }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.getTag(tagId).name), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _createVNode("div", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(cardSetAssemblyPart.cards, (card) => {
            return (_openBlock(), _createBlock(_component_el_card, {
              class: "card",
              key: card.id
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_el_image, {
                    class: "image",
                    src: card.cardUrl,
                    "preview-src-list": cardSetAssemblyPart.cards.map(c => c.cardUrl)
                  }, null, 8, ["src", "preview-src-list"]),
                  (cardSetAssemblyPart.textVisible)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(card.cardText), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_7, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(card.cardTags, (cardTag) => {
                    return (_openBlock(), _createBlock(_component_el_tag, { key: cardTag }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.getTag(cardTag.tagId).name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
})